<ion-modal #modal class="app-qr-code-scanner" [isOpen]="isScannerOpen">
  <ng-template>
    <button class="dismiss-button" (click)="closeModal()"><ion-icon icon="close-outline" size="large"></ion-icon></button>
    @if(permission) {
      @if (inScanTimeout) {
        <div class="scanner-overlay"></div>
        <ion-spinner class="scanner-spinner"></ion-spinner>
      }
      @if (availableCameras.length > 1) {
        <button class="camera-select" (click)="changeCamera()"><ion-icon icon="camera-reverse-outline" size="large"></ion-icon></button>
        <ion-select #camSelect label="{{ 'qrScanner.availableCameras' | translate }}" [value]="selectedCamera" (ionChange)="selectCamera($event)">
          @for(camera of availableCameras; track camera) {
            <ion-select-option [value]="camera">{{camera.label}}</ion-select-option>
          }
        </ion-select>
      }
      @if (buttons.length > 0) {
        <div class="buttons-bar">
          @for (button of buttons; track button) {
            <button (click)="button.onClick($event)">
              <ion-icon [icon]="button.icon" size="large"></ion-icon>
            </button>
          }
        </div>
      }
      <div class="scanner-extraContent">
        <ng-content></ng-content>
      </div>
    }

    @else {
      <ion-label class="no-permission-label">{{ 'qrScanner.camera-permission' | translate }}</ion-label>
    }
  </ng-template>
</ion-modal>

